var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible",
    clipPath: "url(#clip0_84_4682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.87793 5.46598L10.1683 7.75637L10.1792 7.6364C10.1792 6.43303 9.20128 5.45508 7.9979 5.45508L7.87793 5.46598Z",
    fill: "#71207C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99806 4.00135C10.0049 4.00135 11.6336 5.63008 11.6336 7.6369C11.6336 8.10588 11.5391 8.55306 11.3755 8.96386L13.5023 11.0906C14.6002 10.1745 15.4655 8.98932 15.9999 7.6369C14.7384 4.44491 11.6373 2.18359 7.9981 2.18359C6.98014 2.18359 6.00583 2.36536 5.10059 2.69256L6.67114 4.25946C7.08191 4.09951 7.52908 4.00135 7.99806 4.00135Z",
    fill: "#71207C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.727096 2.01984L2.3849 3.67764L2.71575 4.00849C1.51602 4.94645 0.567144 6.19346 0 7.63674C1.25791 10.8287 4.36265 13.09 7.99819 13.09C9.12522 13.09 10.2013 12.8719 11.1866 12.4756L11.4956 12.7847L13.6151 14.9078L14.5422 13.9844L1.65416 1.09277L0.727096 2.01984ZM4.74802 6.03712L5.8714 7.1605C5.83868 7.31684 5.81687 7.47314 5.81687 7.63674C5.81687 8.84012 6.79482 9.81806 7.99819 9.81806C8.16179 9.81806 8.31813 9.79625 8.47083 9.76353L9.59421 10.8869C9.11067 11.1269 8.57263 11.2723 7.99819 11.2723C5.99138 11.2723 4.36265 9.64356 4.36265 7.63674C4.36265 7.06234 4.50808 6.52427 4.74802 6.03712Z",
    fill: "#71207C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_4682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon_invisible.dbf1a22149d7109585faa0afb4b4ac72.svg";
export { ForwardRef as ReactComponent };